export { GameListSkeleton as SkeletonList } from './GameListSkeleton'
